import WorksheetForm from '~/features/projectWizard/worksheets/common/components/WorksheetForm';
import { WorksheetField } from '../../../../worksheets/common/components/Field';
import { CustomerTypeOptions, CreditRatingOptions } from '~/constants';
import CustomerSavingsForm from './CustomerSavingsForm';

export default function Information () {
  return (
    <WorksheetForm>
      <WorksheetField
        schemaKey="customerName"
        placeholder="Enter customer name"
        helpText='Entity name of who will be signing the offtake contract. Ideally, this is their legal name, but it’s OK if you don’t know that right now.'
      />
      <WorksheetField
        type="dropdown"
        schemaKey="customerType"
        placeholder="Select customer type"
        options={CustomerTypeOptions}
      />
      
      <WorksheetField
        schemaKey="customerCreditRating"
        placeholder="Select credit rating"
        fieldLabel="Customer credit rating"
        helpText="Ratings are considered investment grade if they're rated at or above BBB- (S&P or Fitch), Baa3 (Moody's).  If you don't know, please make your best estimate."
        options={CreditRatingOptions}
      />

      <WorksheetField
        schemaKey="customerCreditComments"
        placeholder="Type here..."
        fieldLabel="Customer credit details"
      />

      <CustomerSavingsForm  />
      
      <WorksheetField
        fieldLabel="Community solar subscription details"
        schemaKey="communitySolarSubscriptionDetails"
        optional
        placeholder="Add any subscriber nuances or requirements here (e.g., LMI percentage, anchor subscribers, residential percentage, etc.)"
        type="textarea"
      />
    </WorksheetForm>
  );
}